import * as THREE from 'three';
import { Entity } from './Entity.js';
import { CONFIG, ASCII_CHARS } from '../core/config.js';

export class Experience extends Entity {
    constructor(x, y, value, scene) {
        super(x, y, ASCII_CHARS.EXPERIENCE, CONFIG.COLORS.EXPERIENCE, scene);
        
        this.value = value;
        this.baseMagnetRange = 6;
        this.collectRange = 1.0;
        this.lifetime = 30; // Expires after 30 seconds
    }
    
    update(deltaTime, camera, gameState) {
        super.update(deltaTime, camera);
        
        this.lifetime -= deltaTime;
        if (this.lifetime < 5) {
            this.opacity = this.lifetime / 5; // Fade out
        }
        
        const player = gameState.player;
        if (!player) return this.lifetime <= 0;
        
        const distToPlayer = this.getDistanceTo(player);
        
        // Use player's magnetic field enhancement
        const magnetRange = this.baseMagnetRange * (player.magnetRange || 1);
        
        if (distToPlayer < magnetRange) {
            // Magnetic attraction to player
            const direction = this.getDirectionTo(player);
            const magnetStrength = Math.max(0.3, (magnetRange - distToPlayer) / magnetRange);
            const speed = 18 * magnetStrength * (player.magnetRange || 1); // Faster with upgrades
            this.position.add(direction.multiplyScalar(speed * deltaTime));
            
            // Check for collection
            if (distToPlayer < this.collectRange) {
                this.collect(player, gameState);
                return true; // Remove this experience
            }
        }
        
        return this.lifetime <= 0;
    }
    
    collect(player, gameState) {
        gameState.stats.experience += this.value * player.expMultiplier;
        
        // Play pickup sound
        if (window.gameAudio) {
            window.gameAudio.playPickup();
        }
        
        // Check for level up
        if (gameState.stats.experience >= gameState.stats.experienceToNext) {
            gameState.levelUp();
        }
        
        this.destroy();
    }
} 